<template>
    <EnrollmentsAddTabAccount @changed-query="fetchEnrollmentsData" class="mt-2 pt-75" />
</template>

<script>
import { onUnmounted, provide, ref } from '@vue/composition-api';
import EnrollmentsAddTabAccount from './EnrollmentsAddTabAccount.vue';
import enrollmentsStoreModule from '../enrollmentsStoreModule';
import store from '@/store';

export default {
    components: { EnrollmentsAddTabAccount },
    setup() {
      const ENROLLMENT_MODULE = 'enrollments'
      const students = ref([])
      const courses = ref([])
      const groups = ref([])
      const terms=ref(null)
      const enrollment = ref({
        'student_id' : null,
        'start_date': null,
        'end_date': null,
        'expiration_date': null,
        'amount': '',
        'first_month_payment':null,
        'monthly_payment': null, 
        'last_month_payment':null,
        'course': null,
        'group_id': null,
      })
      const studentsQuery=ref(null)
      const coursesQuery=ref(null)

      provide('students', students)
      provide('courses', courses)
      provide('groups', groups)
      provide('enrollment', enrollment)
      provide('terms', terms)
      provide('studentsQuery', studentsQuery)
      provide('coursesQuery', coursesQuery)


      if (!store.hasModule(ENROLLMENT_MODULE)) store.registerModule(ENROLLMENT_MODULE, enrollmentsStoreModule)

      onUnmounted(() => {
        if (store.hasModule(ENROLLMENT_MODULE)) store.unregisterModule(ENROLLMENT_MODULE)
      })



      const fetchEnrollmentsData = () => {
        store.dispatch('enrollments/createEnrollment', {
        students_query: studentsQuery.value, 
        courses_query: coursesQuery.value, 
      }).then(response => {
        students.value = response.data.students
        courses.value = response.data.courses
        groups.value = response.data.groups
        terms.value=response.data.terms
      })
      }

      fetchEnrollmentsData()
      

      return {
        fetchEnrollmentsData
      }

    }

}
</script>

<style>

</style>
